import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import localeId from "@angular/common/locales/id";
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { firstValueFrom, timeout } from "rxjs";
import { authInterceptor } from "./app/auth.interceptor";
import { routes } from "./app/pages/app.routes";
import { AuthService } from "./app/services/auth.service";

// Register Indonesian locale
registerLocaleData(localeId);

export function initAuth() {
  return async () => {
    const auth = inject(AuthService);

    // Step 1: Read localStorage and restore state
    auth.initializeAuth();

    // Step 2: If logged in, validate session with backend
    if (auth.isLoggedIn()) {
      try {
        // Validate session by fetching user info with timeout
        await firstValueFrom(
          auth.getUserInfo().pipe(
            timeout(5000), // 5 second timeout
          ),
        );
        console.log("✓ Session validated on bootstrap");
      } catch (err: any) {
        // Session expired or backend unreachable
        console.warn(
          "Session validation failed on bootstrap:",
          err.message || err,
        );
        auth.cleanUpState();
      }
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(initAuth()),
    { provide: LOCALE_ID, useValue: "id-ID" },
  ],
};
